import { render, staticRenderFns } from "./payment-add-modal.vue?vue&type=template&id=4e6cd132&"
import script from "./payment-add-modal.vue?vue&type=script&lang=js&"
export * from "./payment-add-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports